import { Flex, Layout } from "antd";

const props = {
	year: new Date().getFullYear(),
	pp: {
		href: "https://www.equilityhq.com/privacy-policy",
		target: "_blank",
		rel: "noreferrer",
	},
	tu: {
		href: "https://www.equilityhq.com/terms-of-use",
		target: "_blank",
		rel: "noreferrer",
	},
};

export function AppFooter() {
	return (
		<Layout.Footer style={footerStyle}>
			<Flex gap={2} justify="center">
				<span>© 2022 - {props.year}, Equility.</span>
				<span>All rights reserved.</span>
				<span>
					<a {...props.pp} aria-label="Privacy Policy (opens in new tab)">
						Privacy Policy
					</a>{" "}
					and{" "}
					<a {...props.tu} aria-label="Terms of Use (opens in new tab)">
						Terms of Use
					</a>
					.
				</span>
			</Flex>
		</Layout.Footer>
	);
}

const footerStyle: React.CSSProperties = {
	display: "block",
	textAlign: "center",
	fontSize: 12,
	marginTop: "auto",
};
